module.exports = __webpack_public_path__ + "static/media/logo2.2c30c475.png";